import { OrderState } from '../types/orders';

/**
 * Criterio ÚNICO de «esta hija NO es trabajo» en el front (decisión D3,
 * 2026-10-12).
 *
 * - `partial`: borrador del asistente (la actuación aún no se ha completado).
 * - `annulled`: descartada; no representa trabajo hecho.
 *
 * Espejo de `rois-back/src/utils/work-state.helper.ts` (#158), que ya la aplica
 * a Gestión Horaria y a la atribución de trabajo del recorrido. Si cambia allí,
 * cambia aquí, y al revés: `tests/unit/pdf/work-states.spec.ts` fija la lista.
 *
 * La usan los informes que salen de las hijas de un padre (combinado de OT y
 * campaña, actuaciones del recorrido y sus OTs vinculadas): en ellos una
 * actuación en borrador o anulada no tiene página ni cuenta en la portada.
 * Los informes que salen de una selección del usuario (PDF detallado, Excel,
 * históricos) NO la usan: ahí se respeta lo que eligió en la tabla.
 *
 * 🔴 NO usar en el vínculo básica ↔ tramo del recorrido
 * (`utils/segmentLinkedBasicAction.ts`): ahí un borrador RETIENE el tramo a
 * propósito y solo una anulada lo suelta. Es otro concepto.
 */
export const NOT_WORK_STATES: readonly OrderState[] = Object.freeze([
  OrderState.Partial,
  OrderState.Annulled,
]);

/** ¿Cuenta este estado como trabajo? (`partial` y `annulled` → no; sin estado → sí). */
export function isWorkState(state: string | null | undefined): boolean {
  return !(NOT_WORK_STATES as readonly string[]).includes(state ?? '');
}
